<template>
  <div>
    <div @click="show = true">
      <slot />
    </div>

    <StakeModal v-model="show">
      <div class="tw-flex tw-flex-col tw-gap-5 tw-p-5">
        <div class="tw-flex tw-flex-col tw-items-center">
          <h2 class="tw-text-xl tw-font-bold tw-text-gray-700">
            Delete Meeting
          </h2>
        </div>

        <div class="tw-flex tw-flex-col">
          <p>Are you sure you want to delete this meeting?</p>
          <p>This cannot be undone.</p>
        </div>

        <MeetingGlance :meeting="meeting" />

        <div>
          <div
            v-if="deleted"
            class="button-base tw-bg-rose-200 tw-text-rose-700"
          >
            <i class="fa fa-check" />
            Deleted
          </div>

          <div
            v-else-if="deleteInProgress"
            class="button-base tw-bg-gray-200 tw-text-rose-700"
          >
            <i class="fa fa-spinner fa-spin" />
            Deleting
          </div>

          <button
            v-else
            class="button-base tw-bg-rose-600 hover:tw-bg-rose-700 tw-text-white tw-cursor-pointer"
            @click="deleteMeeting"
          >
            <i class="fa fa-trash" />
            Delete
          </button>
        </div>
      </div>
    </StakeModal>
  </div>
</template>


<script>
import StakeModal from '@stakeui/StakeModal.vue';
import MeetingGlance from '@frontend/ui/features/meetings/components/MeetingGlance.vue';

export default {
  name: 'LinkEntityToMeeting',
  components: {
    StakeModal,
    MeetingGlance,
  },
  props: {
    // Inputs
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Local variables
      show: false,
      deleteInProgress: false,
      deleted: false,
    };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    handleSelect(entity) {
      console.log('Entity selected:', entity);
      this.linkToMeeting(entity);
    },
    async linkToMeeting(entity) {
      const res = await fetch(`/api/v1/meetings/${this.meeting.id}/entity/`, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({
          entity_external_id: entity.external_id,
        }),
      });

      if (res.ok) {
        this.$emit('updated', {
          ...this.meeting,
          entity,
        });
      }
    },
    async deleteMeeting(id) {
      this.deleteInProgress = true;

      const res = await fetch(`/api/v1/meetings/${this.meeting.id}/`, {
        method: 'DELETE',
        headers: this.headers,
      });

      if (res.status === 204) {
        this.deleted = true;
        this.$emit('deleted', this.meeting.id);
      }

      this.deleteInProgress = false;
    },
  },
};
</script>


<style scoped>
  .button-base {
    @apply tw-w-full tw-text-lg;
    @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
    @apply tw-flex tw-gap-2 tw-items-center tw-justify-center;
  }
</style>
